import { css } from "styled-components";
import { BTTO_PROFILE_COLORS } from "./elements";

export const isBettoHistoryTenant = window.TENANT === "betto";

export const bettoHistoryBodyBackground = "rgba(3, 98, 212, 0.12)";

export const getBettoHistoryStatusStyles = (status) => {
	if (!status) {
		return css`
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
			border: 1px solid ${BTTO_PROFILE_COLORS.border};
			color: ${BTTO_PROFILE_COLORS.textMuted};
		`;
	}

	if (status === "Won" || status === "Completed") {
		return css`
			background: rgba(20, 200, 82, 0.14);
			border: 1px solid rgba(20, 200, 82, 0.35);
			color: ${BTTO_PROFILE_COLORS.success};
		`;
	}

	if (status === "Lost" || status === "Rejected") {
		return css`
			background: rgba(239, 68, 68, 0.14);
			border: 1px solid rgba(239, 68, 68, 0.35);
			color: ${BTTO_PROFILE_COLORS.danger};
		`;
	}

	return css`
		background: ${BTTO_PROFILE_COLORS.surfaceHover};
		border: 1px solid ${BTTO_PROFILE_COLORS.border};
		color: ${BTTO_PROFILE_COLORS.textMuted};
	`;
};
